const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const prmedia_thermatru_product_logos = {
    area :'PR & Media Therma-Tru',

    ref : 'prmedia_thermatru_product_logos',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Logo Placeholder.png',
    type: 'gallery',
    images:
    [
        { img: 'logos_prmedia/Logo_TT_Corp_CMYK.png',  name: '' },
        { img: 'logos_prmedia/KEYS2SUCCESS LOGO.png', name: '' },
        { img: 'logos_prmedia/Logo_TT-CertInstallerProg_Vert.png', name: ''},
        { img: 'logos_prmedia/Logo_TT-Veris_Vert_95K.png',  name: '' },
        { img: 'logos_prmedia/Logo_TT_Thrive_CMYK.png',  name: ''},

    ],
    parent : 'prmedia_thermatru',
}